module.exports = __webpack_public_path__ + "img/draw.c0a2d810.webp";